import { IMyMillUnitStatus, MyMillUnitStatus } from '@/models/myMill/MyMillUnitStatus';

export interface IDexieMyMillUnitStatus extends IMyMillUnitStatus {
    id?: number;
}

export class DexieMyMillUnitStatus extends MyMillUnitStatus implements IDexieMyMillUnitStatus {
    public id?: number;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDexieMyMillUnitStatus);
    constructor(obj?: any) {
        super(obj && (obj as IMyMillUnitStatus));
        if (obj && obj.id != null) {
            this.id = obj && obj.id;
        }
    }
}
